import { Button } from '@qodana/blocks/lib/components/Button/Button'
import { ExternalLink } from '@qodana/blocks/lib/components/ExternalLink/ExternalLink'

import { useConfig } from '../../../config/useConfig'
import { Error } from '../Error/Error'

import styles from './DisplayPageError.module.css'

type DisplayPageErrorProps = {
	onRefetchClick?: () => void
}

const handleReloadClick = () => window.location.reload()

export const DisplayPageError = ({ onRefetchClick }: DisplayPageErrorProps) => {
	const appConfig = useConfig()

	return (
		<Error
			title={'❌ The page is broken'}
			content={
				<div>
					<span>Possibly we're already fixing it.</span>{' '}
					<span>
						Please,{' '}
						{onRefetchClick ? (
							<Button onClick={onRefetchClick} className={styles.refetchButton} variant={'clear'}>
								try again.
							</Button>
						) : (
							<Button
								onClick={handleReloadClick}
								className={styles.refetchButton}
								variant={'clear'}
							>
								reload the page.
							</Button>
						)}
					</span>
					{!!appConfig.youtrackIssueTemplateUrl && (
						<span>
							You can also report a problem to us via{' '}
							<ExternalLink href={appConfig.youtrackIssueTemplateUrl}>YouTrack</ExternalLink>
						</span>
					)}
				</div>
			}
		/>
	)
}
